import i18n from "../../i18n";

const ui = {
  namespaced: true,
  state: {
    isGlobalDrawerOpen: false,
    isGlobalSearchOverlayOpen: false,
    globalSearchFilter: "",
  },
  mutations: {
    SET_GLOBAL_DRAWER_OPEN(state, open) {
      state.isGlobalDrawerOpen = open;
    },
    SET_GLOBAL_SEARCH_OVERLAY_OPEN(state, open) {
      state.isGlobalSearchOverlayOpen = open;
    },
    SET_GLOBAL_SEARCH_FILTER(state, value) {
      state.globalSearchFilter = value != null ? value : "";
    },
  },
  getters: {
    hasFullscreenOverlay(state) {
      return state.isGlobalDrawerOpen || state.isGlobalSearchOverlayOpen;
    },
    navigationLinks(state, getters, rootState, rootGetters) {
      const hasAdminRights = rootGetters["authAdmin/hasAdminRights"];
      const hideNbInscrits = rootState.hide_nb_inscrits;
      const showParticipantsTab = rootState.showParticipantsTab;
      const base = rootState.module && rootState.module.base;
      if (!base) {
        return [];
      }
      let routes = [];
      if (!hasAdminRights) {
        routes.push({ name: 'Courses', path: `/${base}/courses`, text: i18n.t("navigation.accueil"), icon: "house" });
        routes.push({ name: 'Parcours', path: `/${base}/parcours`, text: i18n.t("les_parcours"), icon: "map" });
      }
      if (!hideNbInscrits) {
        if (showParticipantsTab) {
          routes.push({ name: 'Inscriptions', path: `/${base}/inscriptions`, text: i18n.t("navigation.participants"), icon: "person" });
        } else {
          routes.push({ name: 'Live', path: `/${base}/live`, text: i18n.t("navigation.participants"), icon: "person" });
        }
      }
      if (hasAdminRights) {
        routes.push({ name: 'Live_Carte', path: `/${base}/live_carte`, text: i18n.t("carte_live"), icon: "map" });
      }
      routes.push({ name: 'Live_Passages', path: `/${base}/live_passages`, text: i18n.t("intermediaires"), icon: "geo" });
      routes.push({ name: 'Live_Podiums', path: `/${base}/live_podiums`, text: i18n.t("podiums"), icon: "trophy" });

      if (!hasAdminRights) {

        if (rootState.module.base == "VVX26") {
          routes.push({ name: 'Live_Webcams', path: `/${base}/live_webcams`, text: i18n.t("webcams"), icon: "camera" });
        }
        routes.push({ name: 'Live_Favoris', path: `/${base}/live_favoris`, text: i18n.t("favoris"), icon: "star" });
      }
      if (!hideNbInscrits) {
        routes.push({ name: 'Resultats', path: `/${base}/resultats`, text: i18n.t("resultats"), icon: "list-ol" });
      }
      if (hasAdminRights) {
        routes.push({ name: 'CarteLocalisationUrgence', path: `/${base}/live_carte_urgence`, text: i18n.t("localisation_urgence"), icon: "map" });
        routes.push({ name: 'PCCourse', path: `/${base}/pc-course`, text: i18n.t("pc_course"), icon: "list-ol" });
      }
      return routes;
    },
  },
  actions: {
    openGlobalDrawer({ commit, dispatch }) {
      dispatch("closeGlobalSearchOverlay");
      commit("SET_GLOBAL_DRAWER_OPEN", true);
    },
    closeGlobalDrawer({ commit }) {
      commit("SET_GLOBAL_DRAWER_OPEN", false);
    },
    openGlobalSearchOverlay({ commit, dispatch }) {
      dispatch("closeGlobalDrawer");
      commit("SET_GLOBAL_SEARCH_OVERLAY_OPEN", true);
    },
    closeGlobalSearchOverlay({ commit }) {
      commit("SET_GLOBAL_SEARCH_FILTER", "");
      commit("SET_GLOBAL_SEARCH_OVERLAY_OPEN", false);
    },
    updateGlobalSearchFilter({ commit, state, dispatch }, value) {
      const prev = state.globalSearchFilter || "";
      const next = value || "";
      if (!prev && next) {
        dispatch("openGlobalSearchOverlay");
      } else if (prev && !next) {
        dispatch("closeGlobalSearchOverlay");
        return;
      }
      commit("SET_GLOBAL_SEARCH_FILTER", next);
    },
    closeAllGlobal({ dispatch }) {
      dispatch("closeGlobalDrawer");
      dispatch("closeGlobalSearchOverlay");
    },
  },
};

export default ui;
